import ParentsVerification from '../components/ParentsVerification'
import { parentsVerificationConfig } from './shared/config'

import injectWidget from './shared/injectWidget'

const ParentsVerificationWidget = injectWidget({
  widget: ParentsVerification,
  serviceConfig: parentsVerificationConfig,
})

export default ParentsVerificationWidget
